<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm12 md10 offset-md1>
        <v-card>
          <v-card-title>
            Dividas
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            
            <v-row>
              <v-col cols="6" >
                <v-autocomplete
                    v-model="filtros.idcliente"
                    :items="clientes"
                    class="mr-2 ml-2" 
                    v-show="user?user.acesso != 'Cliente':false"
                    chips
                    color="blue-grey lighten-2"
                    label="Clientes"
                    item-value="_id"
                    item-text="Nome"
                    multiple
                  >
                </v-autocomplete>
              </v-col>
              <v-col>
                <v-autocomplete
                    v-model="filtros.idfuncionario"
                    :items="funcionarios"
                    class="mr-2 ml-2 compact-form" 
                    chips
                    color="blue-grey lighten-2"
                    label="Funcionarios"
                    item-value="_id"
                    item-text="name"
                    multiple
                  >
                </v-autocomplete>
              </v-col>
            </v-row>
            
            <v-row>
              <v-col cols="6" >
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      label="Escolha o mês"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    type="month"
                    no-title
                    scrollable
                    v-on:change="$refs.menu.save(date);"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" >
                <v-btn
                  small 
                  color="green"
                  class="mr-2 ml-2" 
                  @click="exportarExcel(filtros)"
                >
                  <v-icon>assignment</v-icon>
                  Gerar Excel
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import store from "@/store";
  import { mapMutations } from "vuex";
  import usuarioCtrl from "@/services/usuario";
  import clienteCtrl from "@/services/cliente";
  import acordo from "@/services/acordo";
  import moment from "moment";  
  import {json2excel, excel2json} from 'js2excel';

  export default {
    name: 'Email',
    data () {
      return {
        filtros: {},
        clientes: [],
        funcionarios: [],
        user: null,
        date: new Date().toISOString().substr(0, 7),
        menu: false,
      }
    },
    async created () {
      this.setLoading(true);
      this.clientes = await clienteCtrl.getClientes();
      this.funcionarios = await usuarioCtrl.getFuncionarios();
      if (store.getters.user) {
        this.user = await usuarioCtrl.getUsuario(store.getters.user._id);
      }
      this.setLoading(false);
    },
    methods: {
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      async exportarExcel (filtros) {
        
        this.setLoading(true);
        let data = [];
        let parcelas = [];
        if (this.user != null && this.user.acesso == "Cliente") {
          parcelas = await acordo.getParcelas({cliente: this.user.cliente, date: this.date, filtros: this.filtros});
        } else if (this.user != null && (this.user.acesso == "Admin" || this.user.acesso == "Financeiro")) {
          parcelas = await acordo.getParcelas({date: this.date, filtros: filtros});
        }
        parcelas.forEach(parcela => {

          let object = {};
          if (this.user.acesso == "Cliente") {
            object = {
              "Empresa": parcela.acordo.cliente.Nome,
              "Funcionario": parcela.acordo.user.name,
              "Devedor": parcela.acordo.devedor.Nome,
              "Vencimento": moment(parcela.vencimento).format("DD/MM/YYYY"),
              "CPF": parcela.acordo.devedor.CnpjCpf,
              "Status Divida": this.getStatusAcordo(parcela),
              "Pagamento": moment(parcela.dtPagamento).format("DD/MM/YYYY"),
              "Parcela": parcela.numero+'/'+parcela.acordo.parcelas.length,
              "Valor Bruto": this.formatPrice(parcela.cliente),
              "Forma Pagamento": this.getPagamento(parcela.tipoPagamento || parcela.acordo.tipoPagamento)
            }
          } else {
            object = {
              "Empresa": parcela.acordo.cliente.Nome,
              "Funcionario": parcela.acordo.user.name,
              "Devedor": parcela.acordo.devedor.Nome,
              "Vencimento": moment(parcela.vencimento).format("DD/MM/YYYY"),
              "CPF": parcela.acordo.devedor.CnpjCpf,
              "Status Divida": this.getStatusAcordo(parcela),
              "Pagamento": moment(parcela.dtPagamento).format("DD/MM/YYYY"),
              "Parcela": parcela.numero+'/'+parcela.acordo.parcelas.length,
              "Valor Parcela": this.formatPrice(parcela.valor),
              "Valor Bruto": this.formatPrice(parcela.valor-parcela.cliente),
              "Valor Cliente": this.formatPrice(parcela.cliente),
              "Forma Pagamento": this.getPagamento(parcela.tipoPagamento || parcela.acordo.tipoPagamento)
            }
          }
          
          data.push(object);
        });
        try {
            json2excel({
                data,
                name: 'RelatorioAcordo',
                formateDate: 'dd/mm/yyyy'
            });
          
          this.setLoading(false);
        } catch (e) {
          this.setLoading(false);
          console.error('export error');
        }
      },
      
      getStatusAcordo (item) {
        if (item.acordo.StatusAcordo == 9) {
          return 'Acordo Cancelado';
        }
        if (moment(item.vencimento) < moment().subtract(1, 'days') && (item.stPago == 'N')) {
          return 'Acordo em Atraso';
        }
        if (item.acordo.StatusAcordo == 1) {
          return 'Processo Cobrança';
        } else if (item.acordo.StatusAcordo == 2) {
          return 'Aguardando Aprovação';
        } else if (item.acordo.StatusAcordo == 3) {
          return 'Acordo Vigente';
        } else if (item.acordo.StatusAcordo == 6) {
          return 'Acordo Liquidado';
        }
      },
      getPagamento (pagamento) {
        if (pagamento == 1) {
          return 'Boleto';
        } else if (pagamento == 2) {
          return 'Deposito';
        } else if (pagamento == 3) {
          return 'Escritório';
        } else if (pagamento == 4) {
          return 'Na Loja';
        } else if (pagamento == 5) {
          return 'Pix';
        }
      },
      getStatusDivida (divida) {
        if (divida && divida.ValorRepasse === 0) {
          return 'Quitado';
        }
        if (divida.StatusDivida == 1) {
          return 'Processo Cobrança';
        } else if (divida.StatusDivida == 2) {
          return 'Aguardando Aprovação';
        } else if (divida.StatusDivida == 3) {
          return 'Acordo Vigente';
        } else if (divida.StatusDivida == 4) {
          return 'Acordo em Atraso';
        } else if (divida.StatusDivida == 5) {
          return 'Divida Bloqueada';
        } else if (divida.StatusDivida == 6) {
          return 'Deslocalizado';
        } else if (divida.StatusDivida == 8) {
          return 'Bloqueado';
        }
      },
      ...mapMutations({
        setDevedor: "setDevedor",
        setLoading: "setLoading",
      })
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/relatorios/Acordos.vue